<ng-container *ngIf="template && form">
  <lib-survey-page-header
    *ngIf="!options?.hideHeader"
    [title]="template.short_title"
  ></lib-survey-page-header>

  <div class="survey-reactive-content">
    <div class="lib-survey-body__content">
      <div>
        <h2>{{ page.title }}</h2>
        <p [innerHtml]="page.description | safeHtml"></p>
      </div>

      <form [formGroup]="form">
        <div
          *ngFor="let question of questions; first as first"
          class="lib-survey-body__question"
          [ngClass]="{
            'lib-survey-body__question__first': first,
            'lib-survey-body__question__no_title': !question.question
          }"
          #question
          [id]="question.reference"
        >
          <ng-container *ngIf="question.isQuestion; else noQuestion">
            <div
              *ngIf="form.get(question.reference)"
              [ngSwitch]="question.input_type"
              class="lib-survey-body__question__section"
            >
              <h3 *ngIf="question.question">{{ question.question }}</h3>

              <h4 *ngIf="question.span1">{{ question.span1 }}</h4>
              <h4 *ngIf="question.span2">{{ question.span2 }}</h4>

              <p
                *ngIf="question.hint && !question.hintUrl"
                class="lib-survey-body__question-hint"
              >
                {{ question.hint }}
              </p>
              <a
                *ngIf="question.hint && question.hintUrl"
                [href]="question.hintUrl"
                target="_blank"
                class="lib-survey-body__question-hint"
              >
                {{ question.hint }}
              </a>

              <lib-survey-autocomplete-input
                *ngSwitchCase="QuestionInputType.autocomplete"
                [question]="question"
                [formControlName]="question.reference"
              ></lib-survey-autocomplete-input>

              <lib-survey-email-input
                *ngSwitchCase="QuestionInputType.email"
                [question]="question"
                [formControlName]="question.reference"
              ></lib-survey-email-input>

              <lib-survey-number-input
                *ngSwitchCase="QuestionInputType.number"
                [formControlName]="question.reference"
              ></lib-survey-number-input>

              <lib-survey-radio-input
                *ngSwitchCase="QuestionInputType.radio"
                [question]="question"
                [formControlName]="question.reference"
              ></lib-survey-radio-input>

              <lib-survey-range-picker
                *ngSwitchCase="QuestionInputType.range"
                [question]="question"
                [formControlName]="question.reference"
                [isScrolling$]="isScrolling$"
              ></lib-survey-range-picker>

              <lib-survey-select-input
                *ngSwitchCase="QuestionInputType.select"
                [question]="question"
                [formControlName]="question.reference"
              ></lib-survey-select-input>

              <lib-survey-step-picker
                *ngSwitchCase="QuestionInputType.step"
                [question]="question"
                [formControlName]="question.reference"
                [isScrolling$]="isScrolling$"
              ></lib-survey-step-picker>

              <lib-survey-text-input
                *ngSwitchCase="QuestionInputType.text"
                [formControlName]="question.reference"
              ></lib-survey-text-input>

              <lib-survey-medications
                *ngSwitchCase="QuestionInputType.medicament"
                [formControlName]="question.reference"
              ></lib-survey-medications>

              <lib-survey-time-picker
                *ngSwitchCase="QuestionInputType.timePicker"
                [formControlName]="question.reference"
              ></lib-survey-time-picker>

              <lib-survey-input-validated-data
                *ngSwitchCase="QuestionInputType.text_with_validation"
                [formControlName]="question.reference"
                [question]="question"
              ></lib-survey-input-validated-data>
            </div>
          </ng-container>

          <ng-template #noQuestion>
            <div
              *ngIf="!question.isConditional || form.get(question.reference)"
              [class]="{
                'lib-survey-body__question__section': !!question.question
              }"
            >
              <h3 *ngIf="question.question">{{ question.question }}</h3>
              <p
                *ngIf="question.hint"
                class="lib-survey-body__question-paragraph"
                [innerHtml]="question.hint | safeHtml"
              ></p>
            </div>
          </ng-template>
        </div>

        <div class="lib-survey-body__page-progress">
          <div
            *ngFor="let p of template?.pages"
            class="lib-survey-body__page-progress-item"
            [class]="{
              'lib-survey-body__page-progress-item--selected': p === page
            }"
          ></div>
        </div>

        <div class="lib-survey-body__buttons-row" (click)="displayErrors()">
          <button
            mat-button
            data-test="previous-message"
            type="button"
            (click)="onPrevious()"
          >
            <mat-icon color="#301D5E" style="margin-right: 5px"
              >keyboard_backspace</mat-icon
            >
            Retour
          </button>
          <button
            mat-raised-button
            color="primary"
            data-test="next-response-page"
            type="button"
            [disabled]="!form.valid && form.enabled"
            (click)="onNext()"
          >
            <ng-container *ngIf="!isLastPage">Suivant</ng-container>
            <ng-container *ngIf="isLastPage">
              {{
                options?.submitOnLastQuestion ? options?.submitLabel : 'Suivant'
              }}
            </ng-container>
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-container>
